import { ContentLink } from "@/components/core/content-link";
import { PageContainer } from "@/components/core/page-container";
import type { FooterGroup } from "@/types/site";

interface FooterProps {
  groups: FooterGroup[];
  siteName: string;
  tagline: string;
}

export function Footer({
  groups,
  siteName,
  tagline,
}: FooterProps): JSX.Element {
  const links = groups
    .flatMap((group) => group.links)
    .filter((link, index, items) => {
      return (
        items.findIndex((candidate) => candidate.href === link.href) === index
      );
    });

  return (
    <footer className="py-8">
      <PageContainer>
        <div className="spotify-divider mb-8" />
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div className="space-y-2">
            <ContentLink className="text-lg font-bold text-foreground" href="/">
              {siteName}
            </ContentLink>
            <p className="max-w-md text-sm leading-6 text-spotify-silver">
              {tagline}
            </p>
          </div>
          <nav
            aria-label="Footer"
            className="flex flex-wrap gap-x-6 gap-y-3 text-sm text-spotify-silver"
          >
            {links.map((link) => (
              <ContentLink
                className="transition hover:text-foreground"
                href={link.href}
                key={`${link.href}-${link.label}`}
              >
                {link.label}
              </ContentLink>
            ))}
          </nav>
        </div>
      </PageContainer>
    </footer>
  );
}
